import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column-space" }

import getGpsTrackerSettingResponse from '@/types/responses/getGpsTrackerSetting'
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue"
import { formatDateTime } from "@/services/functions";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListRow',
  props: {
    gpsTrackerSetting: {},
    showDeleteButton: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function driverName(setting: getGpsTrackerSettingResponse): string {
  if (setting.common_driver_account) {
    return `${setting.common_driver_account.last_name} ${setting.common_driver_account.first_name}`
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("tbody", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(__props.gpsTrackerSetting.id), 1),
      _createElementVNode("td", null, _toDisplayString(__props.gpsTrackerSetting.operation_office.operation_office_name), 1),
      _createElementVNode("td", null, _toDisplayString(__props.gpsTrackerSetting.trip_start_time?.slice(0, 5)), 1),
      _createElementVNode("td", null, _toDisplayString(driverName(__props.gpsTrackerSetting)), 1),
      _createElementVNode("td", _hoisted_1, [
        _createVNode(EditLinkIcon, {
          name: 'GpsTrackerSettingForm',
          id: __props.gpsTrackerSetting.id
        }, null, 8, ["id"])
      ]),
      _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(new Date(__props.gpsTrackerSetting.updated_at))), 1),
      _createElementVNode("td", null, [
        (props.showDeleteButton)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "",
              variant: "text",
              size: "small",
              color: "error",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete', __props.gpsTrackerSetting.id)))
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "delete", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})